/** Pretty-prints an audit entry's details: JSON indented, anything else verbatim. */
export function formatDetails(details: string | null): { text: string; isJson: boolean } {
  if (!details) return { text: '-', isJson: false };
  try {
    return { text: JSON.stringify(JSON.parse(details), null, 2), isJson: true };
  } catch {
    return { text: details, isJson: false };
  }
}

// whitespace-pre-wrap + break-words: keeps the JSON indentation but wraps long
// values (a 1,800-char entry, an unbroken id) instead of scrolling sideways at
// 375px. max-h-80 + overflow-y-auto caps the tallest entries.
export function AuditDetails({ details }: { details: string | null }) {
  const { text } = formatDetails(details);
  return (
    <pre className="text-xs font-mono text-content whitespace-pre-wrap break-words max-h-80 overflow-y-auto rounded-md bg-surface-raised p-3">
      {text}
    </pre>
  );
}
